import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Typography, Space, Spin, Button, Row, Col } from 'antd';
import oslologo from "../assets/images/oslo-badge-new.png";
import yallalogo from "../assets/images/yalla-logo.png";
import tamaralogo from "../assets/images/tamara-en.png"; // Add Tamara logo
import { makePaymentBroker, makePaymentBrokerTamara } from '../api/pets-api';
import { popupMessages } from '../helpers/utilities';

const { Title, Paragraph } = Typography;

const PaymentSelection = () => {
    const { paymentid } = useParams();
    const history = useHistory();

    const [isError, setIsError] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    
    // Remove auto-invoke useEffect
    // useEffect(() => {
    //     if (paymentid) {
    //         processPayment(paymentid);
    //     }
    // }, [paymentid]);

    const processPayment = async (paymentMethod) => {
        setIsProcessing(true);
        try {
            let response;
            
            if (paymentMethod === 'mi') {
                // Tamara installment payment - use new endpoint
                const payload = { 
                    id: paymentid,
                    installmentCount: 4
                };
                console.log("Invoking makePaymentBrokerTamara with:", payload);
                
                response = await makePaymentBrokerTamara(payload);
                
                if (response && response.data && response.data.status === "ok" && response.data.result?.checkout_url) {
                    console.log("Redirecting to Tamara checkout:", response.data.result.checkout_url);
                    window.location.href = response.data.result.checkout_url;
                } else {
                    popupMessages("Payment failed or missing checkout URL.", 'warning');
                    setIsError(true);
                    setIsProcessing(false);
                }
            } else {
                // Annual payment - use existing endpoint
                const payload = { 
                    id: paymentid,
                    paymentMethod: paymentMethod // 'ot' for one-time
                };
                console.log("Invoking makePaymentBroker with:", payload);
                
                response = await makePaymentBroker(payload);

                if (response && response.data && response.data.status === "ok" && response.data.result?.gatewaylink) {
                    console.log("Redirecting to:", response.data.result.gatewaylink);
                    window.location.href = response.data.result.gatewaylink;
                } else {
                    popupMessages("Payment failed or missing gateway link.", 'warning');
                    setIsError(true);
                    setIsProcessing(false);
                }
            }
        } catch (error) {
            console.error("Error processing payment:", error);
            popupMessages("Error processing payment: " + (error.response?.data?.message || error.message), 'error');
            setIsError(true);
            setIsProcessing(false);
        }
    };

    return (
        <div className="payment-selection">
            <Card className="w-50 m-5" style={{ height: 'auto' }} bordered={true}>
                {
                    !isProcessing && !isError &&
                    <>
                        <Title level={2} className="title full-width text-center p-5 pb-0 m-0">
                            Select Payment Method
                        </Title>
                        <Title level={4} className="title full-width text-center m-0 mt-3 text-muted">
                            Choose how you want to pay for your insurance
                        </Title>
                        
                        <Row gutter={[20, 20]} className="p-5">
                            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                <div 
                                    className="section-gray pet-summary price-selector p-4 text-center"
                                    style={{ cursor: 'pointer', minHeight: '250px' }}
                                    onClick={() => processPayment('ot')}
                                >
                                    <Title level={3} className="text-light-green">Annual Payment</Title>
                                    <Paragraph className="notes">
                                        Make one time payment and get your coverage instantly
                                    </Paragraph>
                                    <div className="mt-4">
                                        <Button 
                                            size="large" 
                                            type="primary" 
                                            className="btn-red rounded-100"
                                            onClick={() => processPayment('ot')}
                                        >
                                            Pay Now
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                            
                            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                <div 
                                    className="section-gray pet-summary price-selector p-4 text-center"
                                    style={{ cursor: 'pointer', minHeight: '250px' }}
                                    onClick={() => processPayment('mi')}
                                >
                                    <Title level={3} className="text-light-green">
                                        Pay with <img style={{width:100}} src={tamaralogo} alt="Tamara" />
                                    </Title>
                                    <Paragraph className="notes">
                                        Split your payment into 4 monthly installments
                                    </Paragraph>
                                    <div className="mt-4">
                                        <Button 
                                            size="large" 
                                            type="primary" 
                                            className="btn-red rounded-100"
                                            onClick={() => processPayment('mi')}
                                        >
                                            Pay with Installments
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </>
                }
                {
                    isProcessing && !isError &&
                    <>
                        <Title level={2} className="title full-width text-center p-5 pb-0 m-0">
                            Your payment is processing,
                        </Title>
                        <Title level={3} className="title full-width text-center m-0 mt-3">
                            Please wait and refrain from refreshing the page.
                        </Title>
                        <Space justify={"center"} align={'center'} style={{ justifyContent: 'center' }} size={30} className="full-width text-center mt-5">
                            <Spin />
                            <Spin delay={150} />
                            <Spin delay={300} />
                            <Spin delay={450} />
                        </Space>
                        <Title level={3} className="title full-width text-center m-0 mt-5">
                            You will be redirected to the payment gateway.
                        </Title>
                    </>
                }
                {
                    isError &&
                    <>
                        <Title level={2} className="title full-width text-center p-5 pb-0 m-0">
                            Your payment failed to process,
                        </Title>
                        <Title level={3} className="title full-width text-center m-0 mt-3">
                            Please contact support.
                        </Title>
                    </>
                }
                
                <div className='full-width mt-5 p-5 pb-0'>
                    <div className="bottom-footer full-width text-center">
                        <p className="text-center text-black-50">
                            The information contained in this website is for illustrative purposes only and coverage under any pet insurance policy is expressly subject to the terms and conditions of the policy documentation issued by the insurer.
                        </p>
                        <a href="https://www.alittihadalwatani.com/" target={'_blank'} rel="noreferrer" className="insurer-logo-holder">
                            <img className="img-fluid" src="/images/al-ittihad-al-watani-blue.jpg" alt="Al-Ittihad Al-Watani (AIAW)" />
                        </a>
                        <p className="mt-4 text-black-50">
                            © 2021 OSLO FZE, Dubai, United Arab Emirates - All Rights Reserved.
                        </p>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default PaymentSelection;